<template>
  <div class="modal" :class="show && 'is-active'">
    <div @click="close()" class="modal-background"></div>
    <div class="modal-content">
      <div class="box">
        <h1 class="title is-1 text-center">{{ title }}</h1>

        <p class="content text-center">
          Please be certain to enter the user's information correctly
        </p>

        <input
            class="title input"
            v-model="userName"
            placeholder="user's name"
            />
        <input
            class="title input"
            v-model="userEmail"
            placeholder="user's email"
            />
        <p class="control content text-center">
          <span class="select">
            <div class="select">
              <select v-model="newUserRole">
                <option value='teacher'>teacher</option>
                <option value='coach'>coach</option>
              </select>
            </div>
          </span>
          <label class="checkbox">
            <input v-model="sendEmail" type="checkbox">
            Send Email
          </label>
        </p>
        
        <section class="button-container text-center">
          <button
            @click="addUser"
            type='button'
            class='button is-primary'
            :class="loading && 'is-loading'">
            Add
          </button>
          <input
            @click="close()"
            type='button'
            class='button'
            value='Cancel' />
        </section>

      </div>
    </div>
    <button @click="close()" class="modal-close is-large"></button>
  </div>
</template>

<script>
import store from '../store.js'

export default {
  name: 'AddUser',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    message: {
      type: String,
      default: 'Are you sure?',
    },
    title: {
      type: String,
      default: 'Confirm',
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data () {
    return {
      newUserRole: 'teacher',
      userName: '',
      userEmail: '',
      sendEmail: false,
    }
  },
  methods: {
    close () {
      this.$emit('cancel')
    },
    confirm () {
      store.state.userInput = this.userInput
      this.$emit('confirm')
    },
    handleESC (e) {
      const ESC = 27
      if (e.keyCode === ESC) {
        this.$emit('cancel')
      }
    },
    addUser () {
      let isTeacher = true
      let isCoach = false
      if (this.newUserRole === 'coach') {
        isTeacher = false
        isCoach = true
      }
      store.dispatch('addUser', { name: this.userName, email: this.userEmail, isCoach: isCoach, isTeacher: isTeacher, sendEmail: this.sendEmail })
        .then(() => {
          this.userName = ''
          this.userEmail = ''
          this.toggleShowAddUserModal()
          store.commit('notify', { message: `Added a new ${this.newUserRole} user`, level: 'primary' })
        })
        .catch(error => {
          const errorMessage = error.response.data.message
          console.warn('error creating user', error)
          store.commit('notify', { message: `Error: ${errorMessage}`, level: 'danger' })
        })
    },
    toggleShowAddUserModal () {
      store.commit('toggleShowAddUserModal')
    },
  },
  created () {
    document.addEventListener('keydown', this.handleESC)
  },
  beforeDestory () {
    document.removeEventListener('keydown', this.handleESC)
  },
}
</script>

<style lang="scss" scoped>
.text-center {
  text-align: center;
}

.error-container {
  border-radius: 5px;
  padding: 5px;
  border-style: solid;
  border-width: 1px;
  border-color: lightgray;
}
</style>



// WEBPACK FOOTER //
// AddUser.vue?d4a3924a